import { Controller } from "@hotwired/stimulus"

// Adds keyboard shortcuts to a turbo-frame inline edit form:
//   ⌘↵ / Ctrl+↵ — submit
//   Esc        — cancel (clicks the wired cancel link)
//
// Targets:
//   form    — the form element to submit (defaults to the controller element if it's a form)
//   cancel  — the cancel link/button to click on Escape
//   focus   — input to focus and select on connect (e.g. the name field)
export default class extends Controller {
  static targets = ["form", "cancel", "focus"]

  connect() {
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)

    if (this.hasFocusTarget) {
      requestAnimationFrame(() => {
        this.focusTarget.focus()
        if (typeof this.focusTarget.select === "function")
          this.focusTarget.select()
      })
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  onKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault()
      this.submit()
      return
    }
    if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }

  submit() {
    const form = this.formTargetOrElement
    if (form && typeof form.requestSubmit === "function") form.requestSubmit()
  }

  cancel() {
    if (this.hasCancelTarget) this.cancelTarget.click()
  }

  get formTargetOrElement() {
    if (this.hasFormTarget) return this.formTarget
    if (this.element.tagName === "FORM") return this.element
    return this.element.querySelector("form")
  }
}
